"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rowsPerPageOptions = exports.columns = void 0;
var columns = [
    { name: "UNIT NUMBER", uid: "unitNumber" },
    { name: "BUILDING", uid: "buildingCode" },
    { name: "DESCRIPTION", uid: "description" },
    { name: "METERS", uid: "meters" },
    { name: "POWER USAGE (kWh)", uid: "powerUsage" },
    { name: "WATER USAGE (m\u00B3)", uid: "waterUsage" },
    { name: "RECORDS", uid: "records" },
];
exports.columns = columns;
var rowsPerPageOptions = [
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
